// @ts-nocheck
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import styled from 'styled-components';

const StyledAutocomplete = styled(Autocomplete)`
  && {
    &:focus {
      outline: ${({theme}) => theme.colors.primary} auto 1px;
    }
  }
`;

export function FormikAutoCompleteField({ field, form, ...otherProps }) {
  return (
    <StyledAutocomplete
      {...field}
      {...otherProps}
      onChange={(_, input) => form.setFieldValue(field.name, input)}
      onBlur={() => form.setTouched({ [field.name]: true })}
      fullWidth
      options={otherProps.options}
      getOptionLabel={(option: any) => option.name}
      getOptionSelected={(option: any, selected: any) =>
        option.name === selected.name
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={otherProps.label || ''}
          variant="outlined"
          error={form.touched[field.name] && !!form.errors[field.name]}
          helperText={form.touched[field.name] && form.errors[field.name]}
        />
      )}
    />
  );
}
